<template>
  <div>
    <b-card>
      <div class="d-flex justify-content-between align-items-center flex-wrap mb-2">
        <div>
          <h4 class="mb-25">
            Payment sous traitance
          </h4>
          <small class="text-muted">Total COD filtré : {{ formatAmount(totalCodAmount) }} TND</small>
        </div>
        <b-button
          variant="primary"
          :to="{ name: 'payment-sous-traitance-create' }"
        >
          <feather-icon icon="PlusIcon" class="mr-1" />
          Créer
        </b-button>
      </div>

      <vue-good-table
        :columns="columns"
        :rows="paymentRows"
        :is-loading="isLoading"
        :search-options="{ enabled: true, placeholder: 'Rechercher un paiement' }"
        :pagination-options="{ enabled: true, perPage: 20 }"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field === 'status_label'">
            <b-badge
              pill
              :variant="props.row.status === 'paye_recu' ? 'light-success' : 'light-warning'"
            >
              {{ props.row.status_label }}
            </b-badge>
          </span>
          <span v-else-if="props.column.field === 'total_cod_amount'">
            {{ formatAmount(props.row.total_cod_amount) }} TND
          </span>
          <span v-else-if="props.column.field === 'actions'">
            <b-button
              size="sm"
              variant="outline-primary"
              :to="{ name: 'payment-sous-traitance-detail', params: { id: props.row.id } }"
            >
              <feather-icon icon="EyeIcon" />
            </b-button>
          </span>
          <span v-else>{{ props.formattedRow[props.column.field] || '-' }}</span>
        </template>
      </vue-good-table>
    </b-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { VueGoodTable } from 'vue-good-table'

export default {
  name: 'PaymentSousTraitanceIndex',
  components: {
    VueGoodTable,
  },
  computed: {
    ...mapGetters('paymentSousTraitance', ['payments', 'isLoading', 'totalCodAmount']),
    columns() {
      return [
        { label: '#', field: 'id', type: 'number' },
        { label: 'Société', field: 'company_label' },
        { label: 'Statut', field: 'status_label' },
        { label: 'Colis', field: 'orders_count', type: 'number' },
        { label: 'Total COD', field: 'total_cod_amount' },
        { label: 'Créé par', field: 'created_by_label' },
        { label: 'Validé par', field: 'validated_by_label' },
        { label: 'Créé le', field: 'created_at_label' },
        { label: 'Actions', field: 'actions', sortable: false },
      ]
    },
    paymentRows() {
      return this.payments.map(payment => ({
        ...payment,
        company_label: payment.outsourcing_company?.display_name || payment.outsourcing_company?.name || '-',
        status_label: payment.status_display || (payment.status === 'paye_recu' ? 'Payé reçu' : 'Brouillon'),
        created_by_label: payment.created_by?.username || '-',
        validated_by_label: payment.validated_by?.username || '-',
        created_at_label: this.formatDate(payment.created_at),
      }))
    },
  },
  created() {
    this.fetchPayments()
  },
  methods: {
    ...mapActions('paymentSousTraitance', ['fetchPayments']),
    formatDate(value) {
      return value ? new Date(value).toLocaleString('fr-TN') : '-'
    },
    formatAmount(value) {
      return Number(value || 0).toFixed(3)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
